export default "__VITE_ASSET__CLoTapIr__"